// Efeitos com duração (loot e raids). Todos ficam em `state.effects`, com dono,
// alvo e o momento em que expiram.
import type { Effect, EffectExpiry, EffectKind, PlayerId, TerritoryId } from '../types';
import type { Ctx } from './context';

export function addEffect(
  ctx: Ctx,
  kind: EffectKind,
  owner: PlayerId | null,
  expires: EffectExpiry,
  target: { territory?: TerritoryId; link?: [TerritoryId, TerritoryId] } = {},
): Effect {
  const { s } = ctx;
  const effect: Effect = { id: ++s.effectSeq, kind, owner, expires, ...target };
  s.effects.push(effect);
  return effect;
}

export function removeEffect(ctx: Ctx, id: number, announce = false): void {
  const { s } = ctx;
  const idx = s.effects.findIndex((e) => e.id === id);
  if (idx < 0) return;
  const [e] = s.effects.splice(idx, 1);
  if (announce) ctx.events.push({ type: 'effectExpired', effect: e });
}

function expire(ctx: Ctx, pred: (e: Effect) => boolean): void {
  for (const e of ctx.s.effects.filter(pred)) removeEffect(ctx, e.id, true);
}

export function expireTurnStart(ctx: Ctx, p: PlayerId): void {
  expire(ctx, (e) => e.expires.at === 'turnStart' && e.expires.player === p);
}

export function expireTurnEnd(ctx: Ctx, p: PlayerId): void {
  expire(ctx, (e) => e.expires.at === 'turnEnd' && e.expires.player === p);
}

export function expireRoundStart(ctx: Ctx, round: number): void {
  expire(ctx, (e) => e.expires.at === 'roundStart' && e.expires.round <= round);
}

/** Território trocou de dono: marcas sobre ele somem. */
export function clearTerritoryEffects(ctx: Ctx, t: TerritoryId): void {
  expire(ctx, (e) => e.territory === t);
}

/** Jogador eliminado: efeitos criados por ele somem (nunca chegariam ao próximo turno dele). */
export function clearOwnerEffects(ctx: Ctx, p: PlayerId): void {
  expire(ctx, (e) => e.owner === p);
}
